/**
 * NF-1182: Show UpdateRecommended dialog, show in the last of urgent notifications
 * @param $scope {angular.IScope}
 * @param $mdDialog {mdDialog}
 * @param mdPanelRef {MdPanelRef}
 * @param AuthService {AuthService}
 * @param $Config {$Config}
 * @param notification {NotificationModel}
 * @param NotificationService {NotificationService}
 * @constructor
 */
function UpdateRecommendedDialog($scope, $mdDialog, mdPanelRef, AuthService, $Config, notification, NotificationService) {
    $scope.vm = this;
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.mdPanelRef = mdPanelRef;
    this.authService = AuthService;
    this.$Config = $Config;
    this.notification = notification;
    this.notificationService = NotificationService;

    this.installationUrl = notification.KeyValueData ? JSON.parse(notification.KeyValueData).InstallUrl : null;
    this.applicationName = this.$Config.applicationName;
}

UpdateRecommendedDialog.$inject = [
    '$scope',
    '$mdDialog',
    'mdPanelRef',
    'AuthService',
    '$Config',
    'notification',
    'NotificationService'
];

UpdateRecommendedDialog.prototype = {
    installationUrl: null,
    onLaterButtonClick() {
        localStorage.setItem('TimeIgnoreUpdate', new Date().getTime() + '');
        this.close();
    },

    onDownloadAndInstallClick() {
        this.downloadByOpenLink(this.installationUrl);
    },

    /**
     * Open Outside in Apple Store
     * @private
     */
    downloadByOpenLink(url) {
        console.log('Download url: ' + url);
        if (window['cordova']) {
            window['cordova'].InAppBrowser.open(encodeURI(url), '_system');
        } else {
            window.open(url, '_system')
        }
    },
    close() {
        this.mdPanelRef.close();
    }
};


angular.module('shared.checking-new-version-dialog', []).controller('UpdateRecommendedDialog', UpdateRecommendedDialog);